import { createSelector } from '@reduxjs/toolkit'

const shellLayoutSelector = (state) => state.shellLayout ?? { isBookingPreviewOpen: false }

export const isBookingPreviewOpenSelector = createSelector(
  shellLayoutSelector,
  ({ isBookingPreviewOpen }) => Boolean(isBookingPreviewOpen),
)
